import ConfirmationNumberOutlinedIcon from "@mui/icons-material/ConfirmationNumberOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import MergeTypeOutlinedIcon from "@mui/icons-material/MergeTypeOutlined";
import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PageContentShell } from "../../components/layout/PageContentShell";
import { PageHeader } from "../../components/Page/PageHeader";
import { StatCard } from "../../components/StatCard";
import { ticketService, type Quota, type Stats } from "../../services/ticketService";

export function HomePage() {
  const { t } = useTranslation();
  const [stats, setStats] = useState<Stats | null>(null);
  const [quota, setQuota] = useState<Quota | null>(null);

  useEffect(() => {
    void ticketService.stats().then(setStats).catch(() => setStats(null));
    void ticketService.quota().then(setQuota).catch(() => setQuota(null));
  }, []);

  const cards = [
    {
      label: t("home.quota"),
      value: quota?.ticketsRemaining ?? (quota ? "∞" : "—"),
      icon: <Inventory2OutlinedIcon />,
    },
    { label: t("home.open"), value: stats?.openCount ?? "—", icon: <ConfirmationNumberOutlinedIcon /> },
    { label: t("home.merged"), value: stats?.mergedCount ?? "—", icon: <MergeTypeOutlinedIcon /> },
  ];

  return (
    <PageContentShell>
      <PageHeader title={t("home.welcome")} subtitle={t("home.subtitle")} />
      <Grid container spacing={2}>
        {cards.map((card) => (
          <Grid key={card.label} size={{ xs: 12, sm: 4 }}>
            <StatCard icon={card.icon} label={card.label} value={card.value} />
          </Grid>
        ))}
      </Grid>
    </PageContentShell>
  );
}
